export var createQueueAvatarDriver = function (wrapper) {
    var base = wrapper.$('.queue-avatar');
    return {
        getInitials: function () { return base.$('.inner').text(); },
        isProfileImgVisible: function () { return base.$('img').exists(); },
        isInitialsVisible: function () { return base.$('initials').exists(); },
        base: base
    };
};
//# sourceMappingURL=queue-avatar.driver.js.map